import translationNestedEN from './locales/en/generated/translation.nested.json';

/**
 * Sections whose keys are split across the `intake` and `demand` roots while still
 * being addressed by a backend-supplied entity name.
 */
export type NamespacedSection = 'activityLogs' | 'attributeLabels';

export type KeyRoot = 'intake' | 'demand';

const ROOTS: KeyRoot[] = ['demand', 'intake'];

/**
 * Finds which root owns a backend entity's keys within a split section.
 *
 * changeLog entities arrive as opaque strings, so their translation keys are built at
 * runtime rather than through the typed selector. Probing the resource keeps that
 * derivation honest across the intake/demand split: `demandview` resolves to `demand`
 * while the capitalised `DemandView` resolves to `intake`, because that is where each
 * one's keys actually live. A hardcoded entity list would have to guess.
 *
 * Returns null for an entity neither root defines, letting the caller fall back.
 */
export const resolveKeyRoot = (section: NamespacedSection, segment: string): KeyRoot | null =>
  ROOTS.find((root) => Object.hasOwn(translationNestedEN[root][section], segment)) ?? null;
